module.exports = __webpack_public_path__ + "static/housemasters-ea4c24c66329ff89b0f5407a88edc1d2.jpg";